<template>
  <div v-if="showStatus" class="action-success-block d-flex align-center pa-5">
    <span> {{ successText }} </span>

    <v-spacer />

    <v-btn class="close-btn" :min-width="24" :width="24" :height="24" variant="text" @click="hide">
      <v-icon :size="20" color="white"> mdi-close </v-icon>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'SuccessInDialog',
  components: {},
  props: {
    successText: { type: String, default: '' },
  },
  data() {
    return {
      showStatus: false,
    }
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {
    show() {
      this.showStatus = true
    },
    hide() {
      this.showStatus = false
    },
  },
}
</script>
<style lang="scss" scoped>
.action-success-block {
  border: 1px solid $green70;
  background-color: $green70;
  color: white;
  border-radius: 4px;
}
</style>
